// @flow

import React, { Component } from "react";
import { Map, Marker, TileLayer, Tooltip } from "react-leaflet";

export default class LatLonMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPos: null
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.map = this.mapInstance.leafletElement;
    if (
      this.props.currentLocation &&
      this.props.currentLocation.lat &&
      this.props.currentLocation.lng
    ) {
      const flyTo = [
        this.props.currentLocation.lat,
        this.props.currentLocation.lng
      ];
      this.map.flyTo(flyTo, 6);
    }
  }

  handleClick(e) {
    this.setState({ currentPos: e.latlng });
  }

  render() {
    return (
      <div>
        <Map
          center={[40.7127753, -74.0059728]}
          zoom={8}
          onClick={this.props.handleChangeLocation}
          ref={e => {
            this.mapInstance = e;
          }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {this.props.currentLocation &&
            this.props.currentLocation.lat &&
            this.props.currentLocation.lng && (
              <Marker position={this.props.currentLocation}>
                <Tooltip
                  direction="top"
                  offset={[-14.5, -5]}
                  opacity={1}
                  permanent
                >
                  {`[ ${this.props.currentLocation.lat &&
                    this.props.currentLocation.lat.toFixed(6)},${this.props
                    .currentLocation.lng &&
                    this.props.currentLocation.lng.toFixed(6)}]`}
                </Tooltip>
              </Marker>
            )}
        </Map>
      </div>
    );
  }
}
